<template>
  <div>
    <b-row>
      <b-col cols="12">
        <!-- Filtros -->
        <b-card class="mb-1">
          <b-row>
            <b-col cols="12" md="2">
              <b-form-group label="Data Início" label-for="filtro-data-inicio">
                <b-form-input
                  id="filtro-data-inicio"
                  v-model="filter.dataInicio"
                  type="date"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
              <b-form-group label="Data Fim" label-for="filtro-data-fim">
                <b-form-input
                  id="filtro-data-fim"
                  v-model="filter.dataFinal"
                  type="date"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
              <b-form-group label="Tabela" label-for="filtro-tabela">
                <b-form-input
                  id="filtro-tabela"
                  v-model="filter.tabela"
                  type="text"
                  placeholder="Nome da Tabela"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
              <b-form-group label="Operação" label-for="filtro-operacao">
                <b-form-select
                  id="filtro-operacao"
                  v-model="filter.operacao"
                  :options="opcoesOperacao"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
              <b-form-group label="ID do Usuário" label-for="filtro-usuario">
                <b-form-input
                  id="filtro-usuario"
                  v-model="filter.userId"
                  type="number"
                  placeholder="Ex: 5"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2" class="d-flex align-items-center mt-50 gap-50">
              <b-button variant="primary" block @click="aplicarFiltro" class="mr-1">
                <feather-icon icon="SearchIcon" size="14" /> Filtrar
              </b-button>
              <b-button variant="outline-danger" block @click="exportarPdf" class="mt-0">
                <feather-icon icon="FileTextIcon" size="14" /> PDF
              </b-button>
            </b-col>
          </b-row>
        </b-card>

        <!-- Tabela -->
        <b-card title="Logs de Auditoria do Sistema">
          <vue-good-table
            mode="remote"
            :columns="columns"
            :rows="listaLogs"
            :rtl="direction"
            :is-loading.sync="isLoading"
            :pagination-options="{
              enabled: true,
              perPage: tableConfigs.size
            }"
            :total-rows="tableConfigs.totalElements"
            @on-sort-change="onSortChange"
          >
            <template slot="table-row" slot-scope="props">

              <span v-if="props.column.field === 'dataHora'">
                {{ formatDate(props.row.dataHora) }}
              </span>

              <span v-else-if="props.column.field === 'operacao'">
                <b-badge :variant="getOperacaoBadge(props.row.operacao)" pill>
                  {{ props.row.operacao }}
                </b-badge>
              </span>
              
              <span v-else-if="props.column.field === 'userName'">
                {{ props.row.userName || '-' }} <small class="text-muted">(ID: {{props.row.user}})</small>
              </span>

              <!-- Ações -->
              <span v-else-if="props.column.field === 'action'">
                <span class="d-flex align-items-center gap-50">
                  <b-button
                    v-b-tooltip.hover
                    title="Detalhes"
                    variant="flat-info"
                    class="btn-icon rounded-circle"
                    size="sm"
                    @click="abrirModalDetalhes(props.row)"
                  >
                    <feather-icon icon="EyeIcon" size="16" />
                  </b-button>
                </span>
              </span>

              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>

            <!-- Paginação -->
            <template slot="pagination-bottom" slot-scope="props">
              <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                  <span class="text-nowrap">Exibindo</span>
                  <b-form-select
                    v-model="tableConfigs.size"
                    :options="[10, 20, 50, 100]"
                    class="mx-1"
                    @input="handleChangePage(1)"
                  />
                  <span class="text-nowrap">de {{ tableConfigs.totalElements }} registros</span>
                </div>
                <b-pagination
                  v-model="currentPage"
                  :total-rows="tableConfigs.totalElements"
                  :per-page="tableConfigs.size"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @change="handleChangePage"
                >
                  <template #prev-text><feather-icon icon="ChevronLeftIcon" size="18" /></template>
                  <template #next-text><feather-icon icon="ChevronRightIcon" size="18" /></template>
                </b-pagination>
              </div>
            </template>
          </vue-good-table>
        </b-card>
      </b-col>
    </b-row>

    <!-- Modal Detalhes -->
    <b-modal
      id="modal-detalhes-log"
      title="Detalhes do Registro de Auditoria"
      size="xl"
      ok-only
      ok-title="Fechar"
      scrollable
    >
      <div v-if="logSelecionado">
        <b-row class="mb-2">
          <b-col md="3"><strong>Data/Hora:</strong> {{ formatDate(logSelecionado.dataHora) }}</b-col>
          <b-col md="3"><strong>Tabela:</strong> {{ logSelecionado.tabela }}</b-col>
          <b-col md="3"><strong>ID Registro:</strong> {{ logSelecionado.tabelaId }}</b-col>
          <b-col md="3"><strong>Operação:</strong> {{ logSelecionado.operacao }}</b-col>
        </b-row>
        <hr/>
        <b-row>
          <b-col cols="12" md="6">
            <h5 class="text-danger">Valores Antigos</h5>
            <pre class="bg-light p-1 rounded" style="max-height: 400px; overflow-y: auto;">{{ formatJson(logSelecionado.valoresAntigos) }}</pre>
          </b-col>
          <b-col cols="12" md="6">
            <h5 class="text-success">Valores Novos</h5>
            <pre class="bg-light p-1 rounded" style="max-height: 400px; overflow-y: auto;">{{ formatJson(logSelecionado.valoresNovos) }}</pre>
          </b-col>
        </b-row>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import { VueGoodTable } from 'vue-good-table'
import {
  BRow, BCol, BCard, BBadge, BButton,
  BPagination, BFormGroup, BFormInput, BFormSelect, BModal, VBTooltip
} from 'bootstrap-vue'
import store from '@/store/index'

export default {
  name: 'AuditLogsList',
  components: {
    BRow, BCol, BCard, BBadge, BButton, BPagination,
    BFormGroup, BFormInput, BFormSelect, BModal,
    VueGoodTable
  },
  directives: { 'b-tooltip': VBTooltip },

  computed: {
    ...mapState('auditModule', {
      listaLogs: state => state.listaLogs
    }),
    direction() {
      return store.state.appConfig.isRTL
    }
  },

  data() {
    const hoje = new Date()
    const pDia = new Date(hoje.getFullYear(), hoje.getMonth(), 1)
    const toInputDate = d => {
      // Ajuste para pegar dd/MM/yyyy certinho local
      // O input date html5 precisa do formato yyyy-mm-dd
      return d.toISOString().split('T')[0]
    }

    // backend filter requires dd/MM/yyyy. Mas o backend do log tá aceitando LocalDate padrão ISO pelo Spring? 
    // "O backend recebe dd/MM/yyyy"? Vamos mandar dd/MM/yyyy pra garantir como no FilterComponents
    const pad = n => n<10?'0'+n:n
    const toBrDate = d => `${pad(d.getDate())}/${pad(d.getMonth()+1)}/${d.getFullYear()}`

    return {
      isLoading: false,
      filter: {
        dataInicio: toInputDate(pDia),
        dataFinal: toInputDate(hoje),
        tabela: null,
        operacao: null,
        userId: null
      },
      logSelecionado: null,

      opcoesOperacao: [
        { value: null, text: 'Todas' },
        { value: 'INSERT', text: 'Inserção' },
        { value: 'UPDATE', text: 'Atualização' },
        { value: 'DELETE', text: 'Exclusão' }
      ],

      currentPage: 1,
      pageConfig: { page: 1, size: 20 },
      tableConfigs: { totalElements: 0, totalPages: 0, size: 20 },

      columns: [
        { label: 'Data / Hora', field: 'dataHora', sortable: false },
        { label: 'Tabela',      field: 'tabela',   sortable: false },
        { label: 'ID Reg.',     field: 'tabelaId', sortable: false },
        { label: 'Operação',    field: 'operacao', sortable: false },
        { label: 'Usuário',     field: 'userName', sortable: false },
        { label: 'Ações',       field: 'action',   sortable: false }
      ]
    }
  },

  mounted() {
    this.aplicarFiltro()
  },

  methods: {
    getOperacaoBadge(op) {
      if(op === 'INSERT') return 'light-success'
      if(op === 'UPDATE') return 'light-warning'
      if(op === 'DELETE') return 'light-danger'
      return 'light-secondary'
    },
    formatDate(isoString) {
      if(!isoString) return '-'
      const d = new Date(isoString)
      const pad = n => n<10?'0'+n:n
      return `${pad(d.getDate())}/${pad(d.getMonth()+1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
    formatJson(str) {
      if(!str) return 'N/D'
      try {
        const obj = JSON.parse(str)
        return JSON.stringify(obj, null, 2)
      } catch(e) {
        return str
      }
    },
    async aplicarFiltro() {
      this.currentPage = 1
      this.pageConfig.page = 1
      await this.carregarTabela()
    },
    async carregarTabela() {
      this.isLoading = true
      
      const fmtDataInputParaBR = (dIso) => {
         if (!dIso) return null
         const parts = dIso.split('-')
         if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`
         return dIso
      }

      const payload = {
        dataInicio: fmtDataInputParaBR(this.filter.dataInicio),
        dataFinal: fmtDataInputParaBR(this.filter.dataFinal),
        tabela: this.filter.tabela,
        operacao: this.filter.operacao,
        userId: this.filter.userId
      }

      try {
        const result = await this.$store.dispatch('auditModule/buscarComFiltros', {
          filter: payload,
          pageConfig: this.pageConfig
        })

        if (result && result.data) {
          this.tableConfigs.totalElements = result.data.totalElements
          this.tableConfigs.totalPages = result.data.totalPages
          this.tableConfigs.size = result.data.size
        }
      } catch(err) {
        console.error('Erro ao buscar logs', err)
      }
      this.isLoading = false
    },
    handleChangePage(page) {
      this.pageConfig.page = page
      this.pageConfig.size = this.tableConfigs.size
      this.carregarTabela()
    },
    onSortChange(params) {
      // API currently may not support dynamic sorting without changes securely, but standard setup
    },
    abrirModalDetalhes(row) {
      this.logSelecionado = row
      this.$bvModal.show('modal-detalhes-log')
    },
    async exportarPdf() {
      if (!this.listaLogs || this.listaLogs.length === 0) {
        this.$bvToast.toast('Nenhum dado para exportar', { title: 'Atenção', variant: 'warning' })
        return
      }
      
      const fmtDataInputParaBR = (dIso) => {
         if (!dIso) return null
         const parts = dIso.split('-')
         if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`
         return dIso
      }

      // Preparando os logs para o PDF
      const formatDataHora = (isoStr) => {
        if(!isoStr) return '-'
        const d = new Date(isoStr)
        const p = n => n<10?'0'+n:n
        return `${p(d.getDate())}/${p(d.getMonth()+1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`
      }

      const logsParaEnvio = this.listaLogs.map(l => ({
        ...l,
        dataHora: formatDataHora(l.dataHora),
        valoresAntigos: l.valoresAntigos ? JSON.stringify(JSON.parse(l.valoresAntigos)) : '',
        valoresNovos: l.valoresNovos ? JSON.stringify(JSON.parse(l.valoresNovos)) : ''
      }))

      const payload = {
        dataInicioFormatada: fmtDataInputParaBR(this.filter.dataInicio) || '-',
        dataFimFormatada: fmtDataInputParaBR(this.filter.dataFinal) || '-',
        tabela: this.filter.tabela,
        operacao: this.filter.operacao,
        usuarioTexto: this.filter.userId ? `ID: ${this.filter.userId}` : null,
        logs: logsParaEnvio
      }

      this.$bvToast.toast('Gerando PDF...', { title: 'Aguarde', variant: 'info' })
      try {
        const res = await this.$store.dispatch('reportModule/printReportAuditoria', payload)
        if (res && res.error) {
          this.$bvToast.toast(res.error, { title: 'Erro', variant: 'danger' })
        }
      } catch (e) {
        this.$bvToast.toast('Erro ao gerar PDF', { title: 'Erro', variant: 'danger' })
      }
    }
  }
}
</script>

<style scoped>
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
